import React from 'react';

//Third party packages
import zxcvbn from 'zxcvbn';
import { Col, Row } from 'react-bootstrap';

import usePasswordRules from './hooks/usePasswordRules';

export default ({ touched, fieldValue, rules = {} }) => {
  const { passRules, isMinLength, oneUpperCase, oneNumber, oneSymbol } =
    usePasswordRules(rules || {});

  return (
    <Row className="password-rules">
      <Col className="first-column" md={6} lg={6} sm={6} xs={12}>
        <p className="pass-rules">Password Rules:</p>

        <ul>
          {passRules.passMinLength ? (
            <li
              className={
                'pass-list' +
                (isMinLength(fieldValue, passRules.passMinLength)
                  ? ' fulfilled'
                  : touched || fieldValue !== ''
                  ? ' rejected'
                  : '')
              }
            >
              <span>{`${passRules.passMinLength} - ${passRules.passMaxLength}  characters long`}</span>
            </li>
          ) : null}
          {/*{ passRules.passLowerCaseReq ? (
            <li className={ 'pass-list' + ( oneLowerCase( fieldValue ) ? ' fulfilled' : ( touched || fieldValue !== '' ) ? ' rejected': '' ) }>
              <span>At least 1 lower case character (a-z)</span>
            </li>
          ) : null } */}
          {passRules.passUpperCaseReq ? (
            <li
              className={
                'pass-list' +
                (oneUpperCase(fieldValue)
                  ? ' fulfilled'
                  : touched || fieldValue !== ''
                  ? ' rejected'
                  : '')
              }
            >
              <span>At least 1 upper case character (A-Z)</span>
            </li>
          ) : null}
          {passRules.passNumericsReq ? (
            <li
              className={
                'pass-list' +
                (oneNumber(fieldValue)
                  ? ' fulfilled'
                  : touched || fieldValue !== ''
                  ? ' rejected'
                  : '')
              }
            >
              <span>At least 1 number (0-9)</span>
            </li>
          ) : null}
          {passRules.passSpecialCharReq ? (
            <li
              className={
                'pass-list' +
                (oneSymbol(fieldValue)
                  ? ' fulfilled'
                  : touched || fieldValue !== ''
                  ? ' rejected'
                  : '')
              }
            >
              <span>At least 1 symbol (Example: ~!@$)</span>
            </li>
          ) : null}
        </ul>
      </Col>

      <Col className="second-column" md={6} lg={6} sm={6} xs={12}>
        <p className="strength-value">Password Strength</p>

        <div className="strength-meter">
          <div
            className="strength-meter-fill"
            data-strength={zxcvbn(fieldValue).score}
          ></div>
        </div>
      </Col>
    </Row>
  );
};
